import React, { useRef } from "react";
import { useEffect, useState } from "react";
import {
  CompanyManageGetAutoAvrageRate,
  CompanyManageGetAutoStock,
  CompanyManageMyStore,
  PriceGetBaseDataPrice,
  PriceGetBaseDataPriceForUpdate,
  PriceSetPrice,
} from "../../Api/Services";
import { toast } from "react-toastify";
import Zero from "../../assets/Icon/Zero.png";
import up from "../../assets/Icon/icons8-up-40.png";
import down from "../../assets/Icon/icons8-down-40.png";
import warning from "../../assets/Icon/icons8-warning-48.png";
import { useNavigate, useParams } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";

function PricesAE() {
  const [isLoading, setLoading] = useState(true);
  const [LstPrice, setLstPrice] = useState([]);
  const [Data, setData] = useState();
  const [ActiveItem, setActiveItem] = useState({});
  const [DataSort, setDataSort] = useState([]);
  const [Errors, setErrors] = useState([]);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const [Competitor, SetCompetitor] = useState([]);
  const jalaali = require("jalaali-js");
  const [Package, SetPackage] = useState([]);

  const [ShowModal, setShowModal] = useState("");
  const [StorePerce1, setStorePerce1] = useState([]);
  const [StorePerce2, setStorePerce2] = useState([]);
  const [ValueModal, setValueModal] = useState();
  const [FValueModal, setFValueModal] = useState();
  const [FuncModal, setFuncModal] = useState();
  const handleClose = () => setShowModal("");

  const handleShow = (func, Type, FValue) => {
    setValueModal();
    setFuncModal(() => func);
    setShowModal(Type);
    setFValueModal(FValue);
  };

  const handleSave = () => {
    FuncModal(FValueModal, ValueModal);
    handleClose();
  };

  let { extra } = useParams();

  const ChangeActive = (id) => {
    let copy = [...Competitor];
    const exists = copy.includes(id);

    if (exists) {
      copy = copy.filter((item) => item !== id);
    } else {
      copy.push(id);
    }

    SetCompetitor(copy);
  };

  const start = async () => {
    try {
      let ErrorList = [];
      const CompanyManageMyStoreData = await CompanyManageMyStore();
      if (
        CompanyManageMyStoreData.status &&
        CompanyManageMyStoreData.status === 200
      ) {
        let Lstper1 = [];
        let Lstper2 = [];
        for (const item of CompanyManageMyStoreData.data.data) {
          let Per1 = {
            Id: item.companyStoreId,
            Per1: 5,
            Per2: 0.5,
          };
          let Per2 = {
            Id: item.companyStoreId,
            Per1: 2,
            Per2: 2,
          };
          Lstper1.push(Per1);
          Lstper2.push(Per2);
          const CompanyManageGetAutoAvrageRateData =
            await CompanyManageGetAutoAvrageRate(item.companyStoreId);
          if (
            CompanyManageGetAutoAvrageRateData.status &&
            CompanyManageGetAutoAvrageRateData.status === 200
          ) {
            ErrorList.push(...CompanyManageGetAutoAvrageRateData.data.data);
            if (CompanyManageGetAutoAvrageRateData.data.isSuccess) {
              toast.success(
                ` ارتباط با انبار برای نرخ میانگین برقرار شد
                    ${item.companyStoreCompanyName} ${item.companyStoreName}`,
              );
            }
          }
          const CompanyManageGetAutoStockData = await CompanyManageGetAutoStock(
            item.companyStoreId,
          );
          if (
            CompanyManageGetAutoStockData.status &&
            CompanyManageGetAutoStockData.status === 200
          ) {
            ErrorList.push(...CompanyManageGetAutoStockData.data.data);
            if (CompanyManageGetAutoStockData.data.isSuccess) {
              toast.success(
                ` ارتباط با انبار برای موجودی برقرار شد
                    ${item.companyStoreCompanyName} ${item.companyStoreName}`,
              );
            }
          }
        }
        setStorePerce1(Lstper1);
        setStorePerce2(Lstper2);
        setErrors(ErrorList);
      }

      let PriceGetBaseDataPriceData;
      if (extra != 0) {
        PriceGetBaseDataPriceData = await PriceGetBaseDataPriceForUpdate({
          date: extra,
        });
      } else {
        PriceGetBaseDataPriceData = await PriceGetBaseDataPrice();
      }
      if (
        PriceGetBaseDataPriceData.status &&
        PriceGetBaseDataPriceData.status === 200
      ) {
        setData(PriceGetBaseDataPriceData.data.data);
        let modelSort = [];
        let newForm = [];

        PriceGetBaseDataPriceData.data.data.getBaseData.forEach((itempro) => {
          PriceGetBaseDataPriceData.data.data.allCompany.forEach((itemcom) => {
            PriceGetBaseDataPriceData.data.data.allStore
              .filter((w) => w.companyStoreCompanyId == itemcom.companyId)
              .forEach((itemSto) => {
                if (
                  itempro.companyStoreStocks?.find(
                    (w) => w.companyStoreId == itemSto.companyStoreId,
                  )?.stock > 0
                ) {
                  modelSort.push(itempro.id + "-" + itemSto.companyStoreId);
                }
              });
          });
          if (extra != 0) {
            PriceGetBaseDataPriceData.data.data.allStore.forEach((itemss) => {
              let pricesss = itempro.companyStorePricesEdite.find(
                (w) => w.companyStoreId == itemss.companyStoreId,
              )?.price;
              let stockes = itempro.companyStoreStocks.find(
                (w) => w.companyStoreId == itemss.companyStoreId,
              )?.stock;
              if (pricesss > 0 && stockes > 0) {
                newForm.push({
                  ProductId: itempro.id,
                  CompanyStoreId: itemss.companyStoreId,
                  Price: pricesss,
                });
              }
            });
          }
        });
        setDataSort(modelSort);
        setLstPrice(newForm);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const Add = async () => {
    setLoading(true);
    try {
      const PriceSetPricerData = await PriceSetPrice({
        Data: LstPrice.filter((w) => w.Price != ""),
      });
      if (PriceSetPricerData.status && PriceSetPricerData.status === 200) {
        toast.success(" اطلاعات  با موفقیت ثبت  شد");
        navigate("/Panel/Prices");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during login:", error);
    } finally {
      start();
    }
  };

  const handleChangeSearch = (productId, companyStoreId, e) => {
    const newForm = [...LstPrice];
    let item = newForm.find(
      (e) => e.ProductId == productId && e.CompanyStoreId == companyStoreId,
    );
    if (item) {
      item.Price = e.target.value.replaceAll(",", "");
    } else {
      newForm.push({
        ProductId: productId,
        CompanyStoreId: companyStoreId,
        Price: e.target.value.replaceAll(",", ""),
      });
    }
    setLstPrice(newForm);
  };

  const HandelValueMode = (e) => {
    let newForm = [];
    if (ValueModal) {
      newForm = [...ValueModal];
    }
    let item = newForm.find((w) => w.id == e.target.id);
    if (item) {
      item.per = e.target.value;
    } else {
      newForm.push({
        id: e.target.id,
        per: e.target.value,
      });
    }
    setValueModal(newForm);
  };

  const HandelValue2Mode = (e, TypeMdoe) => {
    let newForm = [];
    if (ValueModal) {
      newForm = [...ValueModal];
    }
    let item = newForm.find((w) => w.Id == e.target.id);
    if (item) {
      item[TypeMdoe] = e.target.value;
    } else {
      let Per = {
        Id: e.target.id,
      };
      Per[TypeMdoe] = e.target.value;
      newForm.push(Per);
    }
    setValueModal(newForm);
  };

  const SetSystem1 = (val1, val2) => {
    {
      val2.forEach((element) => {
        if (isNaN(parseFloat(element.Per1))) {
          toast.error("مقدار وارد شده عددی معتبر نیست!");
          return;
        }
        if (isNaN(parseFloat(element.Per2))) {
          toast.error("مقدار وارد شده عددی معتبر نیست!");
          return;
        }
      });

      const newForm = [...LstPrice];
      Data.getBaseData.forEach((itemAll) => {
        Data.allStore.forEach((itemStore) => {
          let item = newForm.find(
            (e) =>
              e.ProductId == itemAll.id &&
              e.CompanyStoreId == itemStore.companyStoreId,
          );
          let checkCount =
            itemAll.companyStoreStocks.find(
              (www) => www.companyStoreId == itemStore.companyStoreId,
            )?.stock > 0;
          if (checkCount) {
            let checkPricees = OfferPriceSystem1(
              itemAll.id,
              itemStore.companyStoreId,
              val2,
            );

            if (checkPricees) {
              const newPrice = Math.floor(checkPricees * 1);
              if (item) {
                item.Price = newPrice;
              } else {
                newForm.push({
                  ProductId: itemAll.id,
                  CompanyStoreId: itemStore.companyStoreId,
                  Price: newPrice,
                });
              }
            }
          }
        });
      });
      setLstPrice(newForm);
      setStorePerce1(val2);
    }
  };

  const SetSystem2 = (val1, val2) => {
    {
      val2.forEach((element) => {
        if (isNaN(parseFloat(element.Per1))) {
          toast.error("مقدار وارد شده عددی معتبر نیست!");
          return;
        }
        if (isNaN(parseFloat(element.Per2))) {
          toast.error("مقدار وارد شده عددی معتبر نیست!");
          return;
        }
      });

      const newForm = [...LstPrice];
      Data.getBaseData.forEach((itemAll) => {
        Data.allStore.forEach((itemStore) => {
          let item = newForm.find(
            (e) =>
              e.ProductId == itemAll.id &&
              e.CompanyStoreId == itemStore.companyStoreId,
          );
          let checkCount =
            itemAll.companyStoreStocks.find(
              (www) => www.companyStoreId == itemStore.companyStoreId,
            )?.stock > 0;
          if (checkCount) {
            let checkPricees = OfferPriceSystem2(
              itemAll.id,
              itemStore.companyStoreId,
              val2,
            );

            if (checkPricees) {
              const newPrice = Math.floor(checkPricees * 1);
              if (item) {
                item.Price = newPrice;
              } else {
                newForm.push({
                  ProductId: itemAll.id,
                  CompanyStoreId: itemStore.companyStoreId,
                  Price: newPrice,
                });
              }
            }
          }
        });
      });
      setLstPrice(newForm);
      setStorePerce2(val2);
    }
  };

  const SetOffer = (val1, val2) => {
    {
      const percent = parseFloat(val2);
      if (isNaN(percent)) {
        toast.error("مقدار وارد شده عددی معتبر نیست!");
        return;
      }

      const userOffer = Data.allUserOffer.find((q) => q.companyName === val1);

      if (!userOffer) return;
      const matchedPrices = Data.getBaseData.flatMap(
        (store) =>
          store?.companyStoreOfferPrices?.filter(
            (price) =>
              price.createdDate === userOffer.lastTiem &&
              price.userId === userOffer.userId,
          ) || [],
      );
      const newForm = [...LstPrice];
      matchedPrices.map((NPrice) => {
        const NewPrice = Math.floor(
          NPrice.price + (NPrice.price * percent) / 100,
        );

        let checkStore =
          Data.getBaseData
            .find((w) => w.id == NPrice.productId)
            ?.companyStoreStocks.find(
              (w) => w.companyStoreId == NPrice.companyStoreId,
            )?.stock > 0;
        if (checkStore) {
          let item = newForm.find(
            (e) =>
              e.ProductId == NPrice.productId &&
              e.CompanyStoreId == NPrice.companyStoreId,
          );
          if (item) {
            item.Price = NewPrice;
          } else {
            newForm.push({
              ProductId: NPrice.productId,
              CompanyStoreId: NPrice.companyStoreId,
              Price: NewPrice,
            });
          }
        }
      });
      setLstPrice(newForm);
    }
  };

  const SetLast = (val1, val2) => {
    {
      const percent = parseFloat(val2);
      if (isNaN(percent)) {
        toast.error("مقدار وارد شده عددی معتبر نیست!");
        return;
      }

      const matchedPrices = Data.getBaseData.flatMap(
        (store) => store?.companyStorePrices,
      );

      const newForm = [...LstPrice];

      matchedPrices.forEach((NewPrice) => {
        let checkStore =
          Data.getBaseData
            .find((w) => w.id == NewPrice.productId)
            ?.companyStoreStocks.find(
              (w) => w.companyStoreId == NewPrice.companyStoreId,
            )?.stock > 0;

        if (checkStore) {
          const newPricees = Math.floor(
            NewPrice.price + (NewPrice.price * percent) / 100,
          );

          let item = newForm.find(
            (e) =>
              e.ProductId == NewPrice.productId &&
              e.CompanyStoreId == NewPrice.companyStoreId,
          );
          if (item) {
            item.Price = newPricees;
          } else {
            newForm.push({
              ProductId: NewPrice.productId,
              CompanyStoreId: NewPrice.companyStoreId,
              Price: newPricees,
            });
          }
        }
      });
      setLstPrice(newForm);
    }
  };

  const SetAvrage = (val1, val2) => {
    val2.forEach((element) => {
      const percent = parseFloat(element.per);
      if (isNaN(percent)) {
        toast.error("مقدار وارد شده عددی معتبر نیست!");
        return;
      }
    });

    const matchedPrices = Data.getBaseData.flatMap(
      (store) => store?.companyStoreAverageRates,
    );

    const newForm = [...LstPrice];

    matchedPrices.forEach((NewPrice) => {
      let checkStore =
        Data.getBaseData
          .find((w) => w.id == NewPrice.productId)
          ?.companyStoreStocks.find(
            (w) => w.companyStoreId == NewPrice.companyStoreId,
          )?.stock > 0;

      let percent = val2.find((w) => w.id == NewPrice.companyStoreId)?.per;

      if (checkStore) {
        const newPricees = Math.floor(
          NewPrice.price + (NewPrice.price * percent) / 100,
        );

        let item = newForm.find(
          (e) =>
            e.ProductId == NewPrice.productId &&
            e.CompanyStoreId == NewPrice.companyStoreId,
        );
        if (item) {
          item.Price = newPricees;
        } else {
          newForm.push({
            ProductId: NewPrice.productId,
            CompanyStoreId: NewPrice.companyStoreId,
            Price: newPricees,
          });
        }
      }
    });
    setLstPrice(newForm);
  };

  const SetPriceCompetitor = (val1, val2) => {
    val2.forEach((element) => {
      const percent = parseFloat(element.per);
      if (isNaN(percent)) {
        toast.error("مقدار وارد شده عددی معتبر نیست!");
        return;
      }
    });

    const newForm = [...LstPrice];

    Data.getBaseData.forEach((elementPro) => {
      elementPro.companyStoreStocks.forEach((elementStore) => {
        if (elementStore.stock > 0) {
          let price = elementPro.competitorPrices.find(
            (w) => w.competitorId == val1,
          )?.price;
          if (price) {
            let percent = val2.find(
              (w) => w.id == elementStore.companyStoreId,
            )?.per;
            if (percent) {
              let newPricees = Math.floor(price + (price * percent) / 100);
              let item = newForm.find(
                (e) =>
                  e.ProductId == elementPro.id &&
                  e.CompanyStoreId == elementStore.companyStoreId,
              );
              if (item) {
                item.Price = newPricees;
              } else {
                newForm.push({
                  ProductId: elementPro.id,
                  CompanyStoreId: elementStore.companyStoreId,
                  Price: newPricees,
                });
              }
            }
          }
        }
      });
    });
    setLstPrice(newForm);
  };

  const SetPriceAvrageCompetitor = (val1, val2) => {
    val2.forEach((element) => {
      const percent = parseFloat(element.per);
      if (isNaN(percent)) {
        toast.error("مقدار وارد شده عددی معتبر نیست!");
        return;
      }
    });

    const newForm = [...LstPrice];

    Data.getBaseData.forEach((elementPro) => {
      elementPro.companyStoreStocks.forEach((elementStore) => {
        if (elementStore.stock > 0) {
          let cat = Data.allCategory.find((w) => w.id == val1);
          let price =
            elementPro.competitorPrices
              .filter((e) =>
                cat.competitorCategoryCompetitors.some(
                  (w) =>
                    w.id == e.competitorId && e.createdDate == w.deletedDate,
                ),
              )
              .map((w) => w.price)
              .reduce((sum, value) => sum + value, 0) /
            elementPro.competitorPrices.filter((e) =>
              cat.competitorCategoryCompetitors.some(
                (w) => w.id == e.competitorId && e.createdDate == w.deletedDate,
              ),
            ).length;

          if (price) {
            let percent = val2.find(
              (w) => w.id == elementStore.companyStoreId,
            )?.per;
            if (percent) {
              let newPricees = Math.floor(price + (price * percent) / 100);
              let item = newForm.find(
                (e) =>
                  e.ProductId == elementPro.id &&
                  e.CompanyStoreId == elementStore.companyStoreId,
              );
              if (item) {
                item.Price = newPricees;
              } else {
                newForm.push({
                  ProductId: elementPro.id,
                  CompanyStoreId: elementStore.companyStoreId,
                  Price: newPricees,
                });
              }
            }
          }
        }
      });
    });
    setLstPrice(newForm);
  };

  const OfferPriceSystem1 = (productId, storeId, per) => {
    let copyStorePerce = [];
    if (per) {
      copyStorePerce = per;
    } else {
      copyStorePerce = StorePerce1;
    }
    let Per1 = copyStorePerce.find((w) => w.Id == storeId)?.Per1;
    let Per2 = copyStorePerce.find((w) => w.Id == storeId)?.Per2;

    var product = Data.getBaseData.find((w) => w.id == productId);
    var averageRate = product.companyStoreAverageRates.find(
      (w) => w.companyStoreId == storeId,
    )?.price;
    if (averageRate) {
      var store = Data.allStore.find((w) => w.companyStoreId == storeId);
      var categoryid = [
        ...new Set(
          store.companyStoreCompanyStoreCompetitors.map(
            (item) => item.competitorCategoryId,
          ),
        ),
      ];

      let allCategoryNeed = Data.allCategory.filter((q) =>
        categoryid.includes(q.competitorCategoryId),
      );

      let compo = allCategoryNeed
        .map((item) => item.competitorCategoryCompetitors)
        .flat();

      let CategoryCompetitor = product.competitorPrices.filter(
        (item) =>
          compo.some((e) => e.id == item.competitorId) &&
          item.createdDate ==
            compo.find((e) => e.id == item.competitorId)?.deletedDate,
      );

      if (CategoryCompetitor.length > 0) {
        let num = 0;
        let count = 0;
        let z = 0;
        let x = 0;
        let y = 0;
        x = averageRate + Math.floor((averageRate * Per1) / 100);
        CategoryCompetitor.map((itemDe) => {
          if (itemDe.price > 0) {
            num = num + itemDe.price;
            count++;
          }
        });
        y = Math.floor(num / count);

        if (x > y || x < y) {
          z = Math.floor(y + (y * Per2) / 100);
        }
        if (x == y) {
          z = y;
        }
        let Amount = z != 0 ? z.toString().slice(0, -1) + "9" : "0";
        return Amount;
      }
    }
  };

  const OfferPriceSystem2 = (productId, storeId, per) => {
    let copyStorePerce = [];
    if (per) {
      copyStorePerce = per;
    } else {
      copyStorePerce = StorePerce2;
    }
    let Per1 = copyStorePerce.find((w) => w.Id == storeId)?.Per1;
    let Per2 = copyStorePerce.find((w) => w.Id == storeId)?.Per2;

    var product = Data.getBaseData.find((w) => w.id == productId);
    var averageRate = product.companyStoreAverageRates.find(
      (w) => w.companyStoreId == storeId,
    )?.price;
    if (averageRate) {
      var store = Data.allStore.find((w) => w.companyStoreId == storeId);
      var categoryid = [
        ...new Set(
          store.companyStoreCompanyStoreCompetitors.map(
            (item) => item.competitorCategoryId,
          ),
        ),
      ];

      let allCategoryNeed = Data.allCategory.filter((q) =>
        categoryid.includes(q.competitorCategoryId),
      );

      let compo = allCategoryNeed
        .map((item) => item.competitorCategoryCompetitors)
        .flat();

      let CategoryCompetitor = product.competitorPrices.filter(
        (item) =>
          compo.some((e) => e.id == item.competitorId) &&
          item.createdDate ==
            compo.find((e) => e.id == item.competitorId)?.deletedDate,
      );

      if (CategoryCompetitor.length > 0) {
        let num = 0;
        let count = 0;
        let z = 0;
        let y = 0;

        CategoryCompetitor.map((itemDe) => {
          if (itemDe.price > 0) {
            num = num + itemDe.price;
            count++;
          }
        });
        y =
          Math.floor(num / count) +
          Math.floor((Math.floor(num / count) * Per1) / 100);
        if (y >= averageRate) {
          z = y;
        } else {
          z = averageRate + Math.floor((averageRate * Per2) / 100);
        }

        let Amount = z != 0 ? z.toString().slice(0, -1) + "9" : "0";
        return Amount;
      }
    }
  };

  const checkColor = (ProId, storeID, Avrager) => {
    var Pish = LstPrice.find(
      (e) => e.ProductId == ProId && e.CompanyStoreId == storeID,
    )?.Price;
    if (Pish && Avrager) {
      if (Pish < Avrager) {
        return "ghermez";
      }
      if (Pish > Avrager) {
        return "Sabz";
      }
      if (Pish == Avrager) {
        return "";
      }
    } else {
      return "Zard";
    }
  };

  const ManageSod = (ProId, storeID) => {
    let av = Data?.getBaseData
      ?.find((w) => w.id == ProId)
      ?.companyStoreAverageRates.find(
        (w) => w.companyStoreId == storeID,
      )?.price;
    let Pri = LstPrice?.find(
      (w) => w.ProductId == ProId && w.CompanyStoreId == storeID,
    )?.Price;
    if (av && Pri) {
      let res1 = Pri - av;
      let res2 = ((Pri - av) / av) * 100;
      return (
        <>
          <td className={res2 > 0 ? "Sabz" : "ghermez"}>{res2.toFixed(2)}%</td>{" "}
          <td className={res1 > 0 ? "Sabz" : "ghermez"}>
            {res1.toLocaleString()}
          </td>
        </>
      );
    } else {
      return (
        <>
          <td>-</td>
          <td>-</td>
        </>
      );
    }
  };

  const ManageActiveItem = (products) => {
    let lst = Data.getBaseData.filter(
      (w) =>
        w.productBerandId == products.productBerandId &&
        w.productTypeId == products.productTypeId &&
        w.productSeriesId == products.productSeriesId &&
        w.symbol == products.symbol &&
        w.productSeriesEndId == products.productSeriesEndId &&
        w.productRamId == products.productRamId &&
        w.productRomId == products.productRomId &&
        w.productNetworkId == products.productNetworkId &&
        w.isInsurance == products.isInsurance &&
        w.productCountryId == products.productCountryId,
    );
    let model = {
      Start: lst[0].id,
      End: lst[lst.length - 1].id,
    };
    setActiveItem(model);
  };

  const CheckStart = (itemPro) => {
    let lst = Data.getBaseData.filter(
      (w) =>
        w.productBerandId == itemPro.productBerandId &&
        w.productTypeId == itemPro.productTypeId &&
        w.productSeriesId == itemPro.productSeriesId &&
        w.symbol == itemPro.symbol &&
        w.productSeriesEndId == itemPro.productSeriesEndId &&
        w.productRamId == itemPro.productRamId &&
        w.productRomId == itemPro.productRomId &&
        w.productNetworkId == itemPro.productNetworkId &&
        w.isInsurance == itemPro.isInsurance &&
        w.productCountryId == itemPro.productCountryId,
    );
    let model = {
      Is: lst[0].id == itemPro.id,
      Count: lst.length,
    };

    return model;
  };

  const CheckPrice = (lastPrice, currentPrice) => {
    if (currentPrice && lastPrice) {
      const diffPercent = ((currentPrice - lastPrice) / lastPrice) * 100;
      if (Math.abs(diffPercent) > 3) {
        return "bg-danger";
      }
    }
  };

  const groupProducts = (products) => {
    let copy = [...Data.getBaseData];
    let res = copy.filter(
      (w) =>
        w.productBerandId == products.productBerandId &&
        w.productTypeId == products.productTypeId &&
        w.productSeriesId == products.productSeriesId &&
        w.symbol == products.symbol &&
        w.productSeriesEndId == products.productSeriesEndId &&
        w.productRamId == products.productRamId &&
        w.productRomId == products.productRomId &&
        w.productNetworkId == products.productNetworkId &&
        w.isInsurance == products.isInsurance &&
        w.productCountryId == products.productCountryId,
    );

    return res;
  };

  const ChangeActivePackage = (id) => {
    let copy = [...Package];
    const exists = copy.includes(id);

    if (exists) {
      copy = copy.filter((item) => item !== id);
    } else {
      copy.push(id);
    }

    SetPackage(copy);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        {ShowModal != "" && (
          <Modal show={true} onHide={handleClose} backdrop="static" centered>
            <Modal.Header className="position-relative">
              <Modal.Title className="w-100 text-center">
                تنظیم مقدار
              </Modal.Title>
              <button
                type="button"
                className="btn-close position-absolute top-0 end-0 mt-3 me-3"
                aria-label="Close"
                onClick={handleClose}
              ></button>
            </Modal.Header>
            <Modal.Body>
              <Form.Label>
                درصد تغییر را وارد کنید (برای تغییر ندادن 0 را وارد کنید ):
              </Form.Label>

              {(ShowModal == "Last" || ShowModal == "Offer") && (
                <Form.Control
                  type="text"
                  placeholder="درصد"
                  value={ValueModal}
                  onChange={(e) => setValueModal(e.target.value)}
                />
              )}

              {(ShowModal == "AvrageCompetitor" ||
                ShowModal == "Avrage" ||
                ShowModal == "Competitor") &&
                Data.allCompany.map((comItem) =>
                  Data.allStore
                    .filter((w) => w.companyStoreCompanyId == comItem.companyId)
                    .map((storItem) => (
                      <Form.Group className="d-flex flex-column pb-3 pt-3 border-bottom border-2 border-secondary">
                        <Form.Label>
                          {comItem.companyName}:{storItem.companyStoreName}
                        </Form.Label>
                        <Form.Control
                          id={storItem.companyStoreId}
                          type="text"
                          placeholder="درصد"
                          value={
                            ValueModal?.find(
                              (w) => w.id == storItem.companyStoreId,
                            )?.per
                          }
                          onChange={(e) => HandelValueMode(e)}
                        />
                      </Form.Group>
                    )),
                )}

              {(ShowModal == "System1" || ShowModal == "System2") &&
                Data.allCompany.map((comItem) =>
                  Data.allStore
                    .filter((w) => w.companyStoreCompanyId == comItem.companyId)
                    .map((storItem) => (
                      <Form.Group className="d-flex flex-column pb-3 pt-3 border-bottom border-2 border-secondary">
                        <Form.Label>
                          {comItem.companyName}:{storItem.companyStoreName}
                        </Form.Label>
                        <Form.Control
                          id={storItem.companyStoreId}
                          type="text"
                          placeholder="درصد بررسی"
                          value={
                            ValueModal?.find(
                              (w) => w.id == storItem.companyStoreId,
                            )?.Per1
                          }
                          onChange={(e) => HandelValue2Mode(e, "Per1")}
                          className="mb-2"
                        />
                        <Form.Control
                          id={storItem.companyStoreId}
                          type="text"
                          placeholder="درصد تغییر"
                          value={
                            ValueModal?.find(
                              (w) => w.id == storItem.companyStoreId,
                            )?.Per2
                          }
                          onChange={(e) => HandelValue2Mode(e, "Per2")}
                        />
                      </Form.Group>
                    )),
                )}

              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  بستن
                </Button>
                <Button variant="success" onClick={handleSave}>
                  اعمال
                </Button>
              </Modal.Footer>
            </Modal.Body>
          </Modal>
        )}
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element">
          <div className="d-flex justify-content-center align-item-center flex-column">
            {Errors.map((item) => (
              <p>{item}</p>
            ))}
          </div>
          <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-1">
            <div>
              <div className="d-flex justify-content-start align-items-center w-100 m-5">
                <button onClick={Add} className="butAU">
                  ثبت
                </button>
              </div>
              <div className="d-flex flex-column">
                {Data?.allCategory.map((itemCategory) => (
                  <div className="d-flex align-item-center border rounded m-2 p-2 bg-info">
                    <div className="d-flex align-items-center">
                      <span> {itemCategory.competitorCategoryName}</span>
                    </div>
                    <div className="d-flex justify-align-center align-item-center flex-wrap">
                      {itemCategory.competitorCategoryCompetitors.map(
                        (item) => (
                          <div
                            className={`border rounded m-2 p-2 pointer ${
                              Competitor.includes(item.id)
                                ? "Actice"
                                : "DeActice"
                            }`}
                            onClick={() => {
                              ChangeActive(item.id);
                            }}
                          >
                            {item.name}
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                ))}
                {Data?.allPackage.length > 0 && (
                  <div className="d-flex align-item-center border rounded m-2 p-2 bg-info">
                    <div className="d-flex align-items-center">
                      <span> سبد</span>
                    </div>
                    <div className="d-flex justify-align-center align-item-center flex-wrap">
                      {Data.allPackage.map((item) => (
                        <div
                          className={`border rounded m-2 p-2 pointer ${
                            Package.includes(item.id) ? "Actice" : "DeActice"
                          }`}
                          onClick={() => {
                            ChangeActivePackage(item.id);
                          }}
                        >
                          {item.competitorName}
                          {item.title != "" && "(" + item.title + ")"}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              {Data && (
                <div className="d-flex justify-content-center align-items-center w-100 tableC">
                  <table className="table" style={{ lineHeight: "normal" }}>
                    <thead className="sticky-header">
                      <tr className="trTable">
                        <th rowSpan={3}>نام</th>
                        <th rowSpan={3}>رنگ</th>
                        {Data.allCategory.map((item, key) => (
                          <React.Fragment key={key}>
                            <th
                              colSpan={
                                item.competitorCategoryCompetitors.filter((w) =>
                                  Competitor.includes(w.id),
                                ).length + 1
                              }
                              className={`${item.competitorCategoryColor}`}
                            >
                              {item.competitorCategoryName}
                            </th>
                          </React.Fragment>
                        ))}
                        {Data.allPackage.length > 0 && (
                          <th colSpan={Package.length + 1}>سبد</th>
                        )}
                        <th rowSpan={3}>شرکت</th>
                        <th rowSpan={3}>انبار</th>
                        <th rowSpan={3}>موجودی</th>
                        <th
                          className="pointer"
                          onClick={() => handleShow(SetAvrage, "Avrage")}
                          rowSpan={3}
                        >
                          نرخ میانگین
                        </th>
                        <th
                          colSpan={
                            [
                              ...new Set(
                                Data.allUserOffer.map(
                                  (item) => item.companyName,
                                ),
                              ),
                            ].length + 2
                          }
                        >
                          پیشنهاد قیمت
                        </th>
                        <th
                          className="pointer"
                          onClick={() => handleShow(SetLast, "Last")}
                          rowSpan={3}
                        >
                          اخرین قیمت
                        </th>
                        <th rowSpan={3}>قیمت</th>
                        <th rowSpan={2} colSpan={2}>
                          محاسبه سود
                        </th>
                      </tr>
                      <tr>
                        {Data.allCategory.map((itemCategory, key) => (
                          <React.Fragment key={key}>
                            <th
                              rowSpan={2}
                              onClick={() =>
                                handleShow(
                                  SetPriceAvrageCompetitor,
                                  "AvrageCompetitor",
                                  itemCategory.id,
                                )
                              }
                              className={`${itemCategory.competitorCategoryColor} pointer`}
                            >
                              میانگین
                            </th>
                            {itemCategory.competitorCategoryCompetitors
                              .filter((e) => Competitor.includes(e.id))
                              .map((item) => (
                                <th
                                  style={{ width: "70px" }}
                                  rowSpan={2}
                                  className={`${itemCategory.competitorCategoryColor} border border-1 border-black pointer`}
                                  key={item.id}
                                  onClick={() =>
                                    handleShow(
                                      SetPriceCompetitor,
                                      "Competitor",
                                      item.id,
                                    )
                                  }
                                >
                                  <div className="tooltip-container">
                                    <span className="tooltip-target">
                                      {item.name}
                                    </span>
                                    <div className="tooltip-box p-3 w-auto">
                                      <span>
                                        {(() => {
                                          const date = new Date(
                                            item.dateLastAuto.replace("T", " "),
                                          );
                                          const jalaaliDate =
                                            jalaali.toJalaali(date);
                                          const year = jalaaliDate.jy;
                                          const month = jalaaliDate.jm
                                            .toString()
                                            .padStart(2, "0");
                                          const day = jalaaliDate.jd
                                            .toString()
                                            .padStart(2, "0");
                                          const hours = date
                                            .getHours()
                                            .toString()
                                            .padStart(2, "0");
                                          const minutes = date
                                            .getMinutes()
                                            .toString()
                                            .padStart(2, "0");
                                          const seconds = date
                                            .getSeconds()
                                            .toString()
                                            .padStart(2, "0");

                                          return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                        })()}
                                      </span>
                                    </div>
                                  </div>
                                </th>
                              ))}
                          </React.Fragment>
                        ))}
                        {Data.allPackage.length > 0 && (
                          <React.Fragment>
                            <th rowSpan={2}>میانگین</th>
                            {Data.allPackage
                              .filter((w) => Package.includes(w.id))
                              .map((item) => (
                                <th
                                  rowSpan={2}
                                  className={`border border-1 border-black`}
                                  key={item.id}
                                >
                                  <div className="tooltip-container">
                                    <span className="tooltip-target">
                                      {item.competitorName}
                                      {item.title != "" &&
                                        "(" + item.title + ")"}
                                    </span>
                                    <div className="tooltip-box p-3">
                                      <span>
                                        {item.createdDate &&
                                          (() => {
                                            const date = new Date(
                                              item.createdDate.replace(
                                                "T",
                                                " ",
                                              ),
                                            );
                                            const jalaaliDate =
                                              jalaali.toJalaali(date);
                                            const year = jalaaliDate.jy;
                                            const month = jalaaliDate.jm
                                              .toString()
                                              .padStart(2, "0");
                                            const day = jalaaliDate.jd
                                              .toString()
                                              .padStart(2, "0");
                                            const hours = date
                                              .getHours()
                                              .toString()
                                              .padStart(2, "0");
                                            const minutes = date
                                              .getMinutes()
                                              .toString()
                                              .padStart(2, "0");
                                            const seconds = date
                                              .getSeconds()
                                              .toString()
                                              .padStart(2, "0");

                                            return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                          })()}
                                      </span>
                                      <br></br>
                                      <span>{item.idAuto}</span>
                                    </div>
                                  </div>
                                </th>
                              ))}
                          </React.Fragment>
                        )}
                        {[
                          ...new Set(
                            Data.allUserOffer.map((item) => item.companyName),
                          ),
                        ].map((itemOffer) => (
                          <th
                            className="pointer"
                            rowSpan={2}
                            onClick={() =>
                              handleShow(SetOffer, "Offer", itemOffer)
                            }
                          >
                            {itemOffer}
                          </th>
                        ))}
                        <th colSpan={2}>سیستم</th>
                      </tr>
                      <tr>
                        <th
                          className="pointer"
                          onClick={() => handleShow(SetSystem1, "System1")}
                        >
                          رقابتی
                        </th>
                        <th
                          className="pointer"
                          onClick={() => handleShow(SetSystem2, "System2")}
                        >
                          سود{" "}
                        </th>
                        <th>درصد</th>
                        <th>میزان</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Data.getBaseData.map((itemPro, keyPro) => (
                        <>
                          {ActiveItem.Start == itemPro.id && (
                            <>
                              <tr className="bg-warning">
                                <td colSpan={100}></td>
                              </tr>
                              <tr className="bg-warning">
                                <td colSpan={100}></td>
                              </tr>
                            </>
                          )}

                          {CheckStart(itemPro).Is && (
                            <>
                              <tr className="bg-primary">
                                <td colSpan={100}></td>
                              </tr>
                            </>
                          )}

                          <tr key={keyPro.id}>
                            {CheckStart(itemPro).Is && (
                              <td
                                rowSpan={
                                  Data.allStore.length *
                                  CheckStart(itemPro).Count
                                }
                                style={{ maxWidth: "100px" }}
                              >
                                <div className="d-flex flex-column">
                                  <span>
                                    {itemPro.productBerandName != " " &&
                                      itemPro.productBerandName + " "}
                                  </span>
                                  <span>
                                    {itemPro.productTypeName != " " &&
                                      itemPro.productTypeName + " "}
                                  </span>
                                  <span>
                                    {itemPro.productSeriesName != " " &&
                                      itemPro.productSeriesName}
                                    {itemPro.symbol}
                                    {itemPro.productSeriesEndName != " "
                                      ? itemPro.productSeriesEndName + " "
                                      : " "}
                                  </span>
                                  <span>
                                    {itemPro.productRamName != " " &&
                                      itemPro.productRamName + "/"}
                                    {itemPro.productRomName != " " &&
                                      itemPro.productRomName + " "}
                                  </span>
                                  <span>
                                    {itemPro.productNetworkName != " " &&
                                      itemPro.productNetworkName + " "}
                                  </span>
                                  <span>
                                    {itemPro.productCountryName != " " &&
                                      itemPro.productCountryName + " "}
                                  </span>
                                  <span> {itemPro.isInsurance && "بیمه"}</span>
                                </div>
                              </td>
                            )}
                            <td
                              rowSpan={Data.allStore.length}
                              style={{ maxWidth: "100px" }}
                            >
                              {itemPro.productColorName}
                            </td>
                            {Data.allCategory.map((itemCategory) => (
                              <>
                                <td
                                  rowSpan={Data.allStore.length}
                                  className={`${itemCategory.competitorCategoryColor}`}
                                >
                                  {itemPro.competitorPrices.filter((e) =>
                                    itemCategory.competitorCategoryCompetitors.some(
                                      (w) =>
                                        w.id == e.competitorId &&
                                        e.createdDate == w.deletedDate,
                                    ),
                                  ).length > 0
                                    ? Math.floor(
                                        itemPro.competitorPrices
                                          .filter((e) =>
                                            itemCategory.competitorCategoryCompetitors.some(
                                              (w) =>
                                                w.id == e.competitorId &&
                                                e.createdDate == w.deletedDate,
                                            ),
                                          )
                                          .map((w) => w.price)
                                          .reduce(
                                            (sum, value) => sum + value,
                                            0,
                                          ) /
                                          itemPro.competitorPrices.filter((e) =>
                                            itemCategory.competitorCategoryCompetitors.some(
                                              (w) =>
                                                w.id == e.competitorId &&
                                                e.createdDate == w.deletedDate,
                                            ),
                                          ).length,
                                      )
                                        ?.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : "-"}
                                </td>
                                {itemCategory.competitorCategoryCompetitors
                                  .filter((e) => Competitor.includes(e.id))
                                  .map((itemCompetitore) => (
                                    <td
                                      rowSpan={Data.allStore.length}
                                      className={`${itemCategory.competitorCategoryColor}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-center flex-column">
                                        {(() => {
                                          const matchedPrice =
                                            itemPro.competitorPrices.find(
                                              (e) =>
                                                e.competitorId ===
                                                itemCompetitore.id,
                                            );
                                          if (matchedPrice) {
                                            const created =
                                              matchedPrice?.createdDate?.toString();
                                            if (created) {
                                              const updated =
                                                itemCompetitore?.deletedDate?.toString();
                                              if (updated) {
                                                return (
                                                  created !== updated && (
                                                    <img
                                                      width="20px"
                                                      height="20px"
                                                      src={Zero}
                                                    />
                                                  )
                                                );
                                              }
                                            }
                                          }
                                        })()}
                                        <span>
                                          {itemPro.competitorPrices.find(
                                            (e) =>
                                              e.competitorId ==
                                              itemCompetitore.id,
                                          ) != null
                                            ? itemPro.competitorPrices
                                                .find(
                                                  (e) =>
                                                    e.competitorId ==
                                                    itemCompetitore.id,
                                                )
                                                ?.price.toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ",",
                                                )
                                            : "-"}
                                        </span>
                                        {(() => {
                                          let ascending = null;
                                          let Count = 0;
                                          let data =
                                            itemPro.competitorPrices.filter(
                                              (e) =>
                                                e.competitorId ==
                                                itemCompetitore.id,
                                            );

                                          if (data) {
                                            if (data.length > 1) {
                                              let lastAmount = data.shift();
                                              data.forEach((item) => {
                                                if (
                                                  item.price < lastAmount.price
                                                ) {
                                                  if (ascending == true) {
                                                    Count++;
                                                  } else {
                                                    Count = 1;
                                                    ascending = true;
                                                  }
                                                }
                                                if (
                                                  item.price > lastAmount.price
                                                ) {
                                                  if (ascending == false) {
                                                    Count++;
                                                  } else {
                                                    Count = 1;
                                                    ascending = false;
                                                  }
                                                }
                                              });
                                            }
                                          }
                                          if (ascending == true) {
                                            return (
                                              <div className="d-flex ">
                                                <span className="Sabz border rounded p-1 me-3">
                                                  {Count && Count}
                                                </span>
                                                <img
                                                  width={"20px"}
                                                  height={"20px"}
                                                  src={up}
                                                />
                                              </div>
                                            );
                                          }
                                          if (ascending == false) {
                                            return (
                                              <div>
                                                <span className="ghermez border rounded p-1 me-3">
                                                  {Count && Count}
                                                </span>
                                                <img
                                                  width={"20px"}
                                                  height={"20px"}
                                                  src={down}
                                                />
                                              </div>
                                            );
                                          }
                                        })()}
                                      </div>
                                    </td>
                                  ))}
                              </>
                            ))}
                            {Data.allPackage.length > 0 && (
                              <React.Fragment>
                                <td rowSpan={Data.allStore.length}>
                                  {(() => {
                                    const average =
                                      groupProducts(
                                        itemPro,
                                      )[0].competitorPackagePrices.reduce(
                                        (sum, item) => sum + item.price,
                                        0,
                                      ) /
                                      groupProducts(itemPro)[0]
                                        .competitorPackagePrices.length;
                                    return average
                                      ? Math.floor(average)
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      : "-";
                                  })()}
                                </td>

                                {Data.allPackage
                                  .filter((w) => Package.includes(w.id))
                                  .map((itemCompetitore) => (
                                    <td
                                      key={itemCompetitore.id}
                                      rowSpan={Data.allStore.length}
                                    >
                                      <div className="d-flex align-item-center justify-content-around">
                                        {(() => {
                                          const price = groupProducts(
                                            itemPro,
                                          )[0]?.competitorPackagePrices?.find(
                                            (e) =>
                                              e.competitorPackageId ==
                                              itemCompetitore.id,
                                          );
                                          return price?.price ? (
                                            <span>
                                              {price.price
                                                .toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ",",
                                                )}
                                            </span>
                                          ) : (
                                            <span>-</span>
                                          );
                                        })()}
                                      </div>
                                    </td>
                                  ))}
                              </React.Fragment>
                            )}

                            <td
                              rowSpan={
                                Data.allStore.filter(
                                  (w) =>
                                    w.companyStoreCompanyId ==
                                    Data.allCompany[0].companyId,
                                ).length
                              }
                            >
                              {Data.allCompany[0].companyName}
                            </td>
                            <td>
                              {
                                Data.allStore.filter(
                                  (w) =>
                                    w.companyStoreCompanyId ==
                                    Data.allCompany[0].companyId,
                                )[0].companyStoreName
                              }
                            </td>
                            <td>
                              {(() => {
                                let a = itemPro.companyStoreStocks.find(
                                  (w) =>
                                    w.companyStoreId ==
                                    Data.allStore.filter(
                                      (w) =>
                                        w.companyStoreCompanyId ==
                                        Data.allCompany[0].companyId,
                                    )[0].companyStoreId,
                                )?.stock;

                                if (a == 0 || a == undefined) {
                                  return "-";
                                } else {
                                  return a;
                                }
                              })()}
                            </td>
                            <td>
                              <div className="d-flex flex-column justify-content-center align-items-center">
                                {(() => {
                                  let a = !isNaN(
                                    Math.floor(
                                      itemPro.companyStoreAverageRates.find(
                                        (w) =>
                                          w.companyStoreId ==
                                          Data.allStore.filter(
                                            (w) =>
                                              w.companyStoreCompanyId ==
                                              Data.allCompany[0].companyId,
                                          )[0].companyStoreId,
                                      )?.price,
                                    ),
                                  )
                                    ? Math.floor(
                                        itemPro.companyStoreAverageRates.find(
                                          (w) =>
                                            w.companyStoreId ==
                                            Data.allStore.filter(
                                              (w) =>
                                                w.companyStoreCompanyId ==
                                                Data.allCompany[0].companyId,
                                            )[0].companyStoreId,
                                        )?.price,
                                      )
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : "-";
                                  if (a == 0) {
                                    return "-";
                                  }
                                  return a;
                                })()}
                                {itemPro.companyStoreAverageRates.find(
                                  (w) =>
                                    w.companyStoreId ==
                                    Data.allStore.filter(
                                      (w) =>
                                        w.companyStoreCompanyId ==
                                        Data.allCompany[0].companyId,
                                    )[0].companyStoreId,
                                )?.isWarning && (
                                  <img
                                    width={"20px"}
                                    height={"20px"}
                                    src={warning}
                                  />
                                )}
                              </div>
                            </td>

                            {[
                              ...new Set(
                                Data.allUserOffer.map((item) => item.userId),
                              ),
                            ].map((itemOffer) => (
                              <td>
                                {(() => {
                                  const companyId =
                                    Data.allCompany[0]?.companyId;
                                  if (!companyId) return "";

                                  const storeId = Data.allStore.find(
                                    (m) =>
                                      m.companyStoreCompanyId === companyId,
                                  ).companyStoreId;
                                  if (!storeId) return "";

                                  const lastTiem = Data.allUserOffer.find(
                                    (q) =>
                                      q.userId === itemOffer &&
                                      q.storeId === storeId,
                                  )?.lastTiem;

                                  if (!lastTiem) {
                                    return "";
                                  }

                                  const priceItem =
                                    itemPro.companyStoreOfferPrices.find(
                                      (w) =>
                                        w.companyStoreId === storeId &&
                                        w.userId === itemOffer &&
                                        w.createdDate === lastTiem,
                                    );

                                  if (!priceItem) return "";
                                  return priceItem.price
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                })()}
                              </td>
                            ))}
                            <td>
                              {(() => {
                                let a = OfferPriceSystem1(
                                  itemPro.id,
                                  Data.allStore.find(
                                    (m) =>
                                      m.companyStoreCompanyId ===
                                      Data.allCompany[0]?.companyId,
                                  ).companyStoreId,
                                );
                                if (a == 0 || a == undefined) {
                                  return "-";
                                } else {
                                  return a
                                    ?.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                }
                              })()}
                            </td>
                            <td>
                              {(() => {
                                let a = OfferPriceSystem2(
                                  itemPro.id,
                                  Data.allStore.find(
                                    (m) =>
                                      m.companyStoreCompanyId ===
                                      Data.allCompany[0]?.companyId,
                                  ).companyStoreId,
                                );
                                if ((a == 0) | (a == undefined)) {
                                  return "-";
                                } else {
                                  return a
                                    ?.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                }
                              })()}
                            </td>
                            <td
                              className={
                                CheckPrice(
                                  itemPro.companyStorePrices.find(
                                    (w) =>
                                      w.companyStoreId ==
                                      Data.allStore.find(
                                        (m) =>
                                          m.companyStoreCompanyId ===
                                          Data.allCompany[0]?.companyId,
                                      ).companyStoreId,
                                  )?.price,
                                  LstPrice.find(
                                    (e) =>
                                      e.ProductId == itemPro.id &&
                                      e.CompanyStoreId ==
                                        Data.allStore.find(
                                          (m) =>
                                            m.companyStoreCompanyId ===
                                            Data.allCompany[0]?.companyId,
                                        ).companyStoreId,
                                  )?.Price,
                                ) +
                                (new Date(
                                  itemPro.companyStorePrices.find(
                                    (w) =>
                                      w.companyStoreId ==
                                      Data.allStore.find(
                                        (m) =>
                                          m.companyStoreCompanyId ===
                                          Data.allCompany[0]?.companyId,
                                      ).companyStoreId,
                                  )?.createdDate,
                                ) <
                                new Date(
                                  new Date().setDate(new Date().getDate() - 1),
                                )
                                  ? " bg-warning"
                                  : "")
                              }
                            >
                              <div className="d-flex flex-column justify-content-center align-items.center">
                                <span>
                                  {itemPro.companyStorePrices
                                    .find(
                                      (w) =>
                                        w.companyStoreId ==
                                        Data.allStore.find(
                                          (m) =>
                                            m.companyStoreCompanyId ===
                                            Data.allCompany[0]?.companyId,
                                        ).companyStoreId,
                                    )
                                    ?.price.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </span>
                                <span>
                                  {(() => {
                                    let a = itemPro.companyStorePrices.find(
                                      (w) =>
                                        w.companyStoreId ==
                                        Data.allStore.find(
                                          (m) =>
                                            m.companyStoreCompanyId ===
                                            Data.allCompany[0]?.companyId,
                                        ).companyStoreId,
                                    );
                                    if (a) {
                                      const date = new Date(
                                        a.createdDate.replace("T", " "),
                                      );
                                      if (date) {
                                        const jalaaliDate =
                                          jalaali.toJalaali(date);
                                        const year = jalaaliDate.jy;
                                        const month = jalaaliDate.jm
                                          .toString()
                                          .padStart(2, "0");
                                        const day = jalaaliDate.jd
                                          .toString()
                                          .padStart(2, "0");
                                        const hours = date
                                          .getHours()
                                          .toString()
                                          .padStart(2, "0");
                                        const minutes = date
                                          .getMinutes()
                                          .toString()
                                          .padStart(2, "0");
                                        const seconds = date
                                          .getSeconds()
                                          .toString()
                                          .padStart(2, "0");
                                        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                      }
                                    }
                                  })()}
                                </span>
                              </div>
                            </td>
                            {/* <td
                              className={
                                CheckPrice(
                                  itemPro.companyStorePrices.find(
                                    (w) =>
                                      w.companyStoreId ==
                                      Data.allStore.find(
                                        (m) =>
                                          m.companyStoreCompanyId ===
                                          Data.allCompany[0]?.companyId
                                      ).companyStoreId
                                  )?.price,
                                  LstPrice.find(
                                    (e) =>
                                      e.ProductId == itemPro.id &&
                                      e.CompanyStoreId ==
                                        Data.allStore.find(
                                          (m) =>
                                            m.companyStoreCompanyId ===
                                            Data.allCompany[0]?.companyId
                                        ).companyStoreId
                                  )?.Price
                                ) +
                                (new Date(
                                  itemPro.companyStorePrices.find(
                                    (w) =>
                                      w.companyStoreId ==
                                      Data.allStore.find(
                                        (m) =>
                                          m.companyStoreCompanyId ===
                                          Data.allCompany[0]?.companyId
                                      ).companyStoreId
                                  )?.createdDate
                                ) <
                                new Date(
                                  new Date().setDate(new Date().getDate() - 1)
                                )
                                  ? " bg-warning"
                                  : "")
                              }
                            >
                              {itemPro.companyStorePrices
                                .find(
                                  (w) =>
                                    w.companyStoreId ==
                                    Data.allStore.find(
                                      (m) =>
                                        m.companyStoreCompanyId ===
                                        Data.allCompany[0]?.companyId
                                    ).companyStoreId
                                )
                                ?.price.toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td> */}
                            <td
                              className={CheckPrice(
                                itemPro.companyStorePrices.find(
                                  (w) =>
                                    w.companyStoreId ==
                                    Data.allStore.find(
                                      (m) =>
                                        m.companyStoreCompanyId ===
                                        Data.allCompany[0]?.companyId,
                                    ).companyStoreId,
                                )?.price,
                                LstPrice.find(
                                  (e) =>
                                    e.ProductId == itemPro.id &&
                                    e.CompanyStoreId ==
                                      Data.allStore.find(
                                        (m) =>
                                          m.companyStoreCompanyId ===
                                          Data.allCompany[0]?.companyId,
                                      ).companyStoreId,
                                )?.Price,
                              )}
                            >
                              {itemPro.companyStoreStocks?.find(
                                (w) =>
                                  w.companyStoreId ==
                                  Data.allStore.find(
                                    (m) =>
                                      m.companyStoreCompanyId ===
                                      Data.allCompany[0]?.companyId,
                                  ).companyStoreId,
                              )?.stock > 0 && (
                                <input
                                  style={{ width: "90px" }}
                                  onFocus={() => {
                                    ManageActiveItem(itemPro);
                                  }}
                                  className={checkColor(
                                    itemPro.id,
                                    Data.allStore.find(
                                      (m) =>
                                        m.companyStoreCompanyId ===
                                        Data.allCompany[0]?.companyId,
                                    ).companyStoreId,
                                    itemPro.companyStoreAverageRates.find(
                                      (w) =>
                                        w.companyStoreId ==
                                        Data.allStore.filter(
                                          (w) =>
                                            w.companyStoreCompanyId ==
                                            Data.allCompany[0].companyId,
                                        )[0].companyStoreId,
                                    )?.price,
                                  )}
                                  id={
                                    itemPro.id +
                                    "-" +
                                    Data.allStore.find(
                                      (m) =>
                                        m.companyStoreCompanyId ===
                                        Data.allCompany[0]?.companyId,
                                    ).companyStoreId
                                  }
                                  ref={(el) =>
                                    (inputRefs.current[
                                      itemPro.id +
                                        "-" +
                                        Data.allStore.find(
                                          (m) =>
                                            m.companyStoreCompanyId ===
                                            Data.allCompany[0]?.companyId,
                                        ).companyStoreId
                                    ] = el)
                                  }
                                  onKeyDown={(e) => {
                                    const currentIndex = DataSort.findIndex(
                                      (item) => item == e.target.id,
                                    );
                                    if (
                                      e.key === "Enter" ||
                                      e.key === "ArrowDown"
                                    ) {
                                      e.preventDefault();
                                      const nextItem =
                                        DataSort[currentIndex + 1];
                                      if (nextItem) {
                                        inputRefs.current[nextItem]?.focus();
                                        setTimeout(() => {
                                          inputRefs.current[nextItem]?.select();
                                        }, 0);
                                      }
                                    } else if (e.key === "ArrowUp") {
                                      e.preventDefault();
                                      const prevItem =
                                        DataSort[currentIndex - 1];
                                      if (prevItem) {
                                        inputRefs.current[prevItem]?.focus();
                                        setTimeout(() => {
                                          inputRefs.current[prevItem]?.select();
                                        }, 0);
                                      }
                                    }
                                  }}
                                  value={LstPrice.find(
                                    (e) =>
                                      e.ProductId == itemPro.id &&
                                      e.CompanyStoreId ==
                                        Data.allStore.find(
                                          (m) =>
                                            m.companyStoreCompanyId ===
                                            Data.allCompany[0]?.companyId,
                                        ).companyStoreId,
                                  )
                                    ?.Price.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  onChange={(e) => {
                                    handleChangeSearch(
                                      itemPro.id,
                                      Data.allStore.find(
                                        (m) =>
                                          m.companyStoreCompanyId ===
                                          Data.allCompany[0]?.companyId,
                                      ).companyStoreId,
                                      e,
                                    );
                                  }}
                                />
                              )}
                            </td>
                            {ManageSod(
                              itemPro.id,
                              Data.allStore.find(
                                (m) =>
                                  m.companyStoreCompanyId ===
                                  Data.allCompany[0]?.companyId,
                              ).companyStoreId,
                            )}
                          </tr>

                          {Data.allStore
                            .filter(
                              (w) =>
                                w.companyStoreCompanyId ==
                                Data.allCompany[0].companyId,
                            )
                            .slice(1)
                            .map((itemstore) => (
                              <tr>
                                <td>{itemstore.companyStoreName}</td>
                                <td>
                                  {(() => {
                                    let a = itemPro.companyStoreStocks.find(
                                      (w) =>
                                        w.companyStoreId ==
                                        itemstore.companyStoreId,
                                    )?.stock;
                                    if (a == undefined || a == 0) {
                                      return "-";
                                    } else {
                                      return a;
                                    }
                                  })()}
                                </td>
                                <td>
                                  <div className="d-flex flex-column justify-content-center align-items-center">
                                    {(() => {
                                      let a = !isNaN(
                                        Math.floor(
                                          itemPro.companyStoreAverageRates.find(
                                            (w) =>
                                              w.companyStoreId ==
                                              itemstore.companyStoreId,
                                          )?.price,
                                        ),
                                      )
                                        ? Math.floor(
                                            itemPro.companyStoreAverageRates.find(
                                              (w) =>
                                                w.companyStoreId ==
                                                itemstore.companyStoreId,
                                            )?.price,
                                          )
                                            ?.toString()
                                            ?.replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            )
                                        : "-";
                                      if (a == 0 || a == undefined) {
                                        return "-";
                                      } else {
                                        return a;
                                      }
                                    })()}
                                    {itemPro.companyStoreAverageRates.find(
                                      (w) =>
                                        w.companyStoreId ==
                                        itemstore.companyStoreId,
                                    )?.isWarning && (
                                      <img
                                        width={"20px"}
                                        height={"20px"}
                                        src={warning}
                                      />
                                    )}
                                  </div>
                                </td>

                                {[
                                  ...new Set(
                                    Data.allUserOffer.map(
                                      (item) => item.userId,
                                    ),
                                  ),
                                ].map((itemOffer) => (
                                  <td>
                                    {(() => {
                                      const storeId = itemstore.companyStoreId;
                                      if (!storeId) return "";

                                      const lastTiem = Data.allUserOffer.find(
                                        (q) =>
                                          q.userId === itemOffer &&
                                          q.storeId === storeId,
                                      )?.lastTiem;
                                      if (!lastTiem) return "";

                                      const priceItem =
                                        itemPro.companyStoreOfferPrices.find(
                                          (w) =>
                                            w.companyStoreId === storeId &&
                                            w.userId === itemOffer &&
                                            w.createdDate === lastTiem,
                                        );

                                      if (!priceItem) return "";

                                      return priceItem.price
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    })()}
                                  </td>
                                ))}
                                <td>
                                  {(() => {
                                    let a = OfferPriceSystem1(
                                      itemPro.id,
                                      itemstore.companyStoreId,
                                    );
                                    if (a == 0 || a == undefined) {
                                      return "-";
                                    } else {
                                      return a
                                        ?.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    }
                                  })()}
                                </td>
                                <td>
                                  {(() => {
                                    let a = OfferPriceSystem2(
                                      itemPro.id,
                                      itemstore.companyStoreId,
                                    );
                                    if (a == 0 || a == undefined) {
                                      return "-";
                                    } else {
                                      return a
                                        ?.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    }
                                  })()}
                                </td>
                                <td
                                  className={
                                    CheckPrice(
                                      itemPro.companyStorePrices.find(
                                        (w) =>
                                          w.companyStoreId ==
                                          itemstore.companyStoreId,
                                      )?.price,
                                      LstPrice.find(
                                        (e) =>
                                          e.ProductId == itemPro.id &&
                                          e.CompanyStoreId ==
                                            itemstore.companyStoreId,
                                      )?.Price,
                                    ) +
                                    (new Date(
                                      itemPro.companyStorePrices.find(
                                        (w) =>
                                          w.companyStoreId ==
                                          itemstore.companyStoreId,
                                      )?.createdDate,
                                    ) <
                                    new Date(
                                      new Date().setDate(
                                        new Date().getDate() - 1,
                                      ),
                                    )
                                      ? " bg-warning"
                                      : "")
                                  }
                                >
                                  <div className="d-flex flex-column justify-content-center align-items.center">
                                    <span>
                                      {itemPro.companyStorePrices
                                        .find(
                                          (w) =>
                                            w.companyStoreId ==
                                            itemstore.companyStoreId,
                                        )
                                        ?.price.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </span>
                                    <span>
                                      {(() => {
                                        let a = itemPro.companyStorePrices.find(
                                          (w) =>
                                            w.companyStoreId ==
                                            itemstore.companyStoreId,
                                        );
                                        if (a) {
                                          const date = new Date(
                                            a.createdDate.replace("T", " "),
                                          );
                                          if (date) {
                                            const jalaaliDate =
                                              jalaali.toJalaali(date);
                                            const year = jalaaliDate.jy;
                                            const month = jalaaliDate.jm
                                              .toString()
                                              .padStart(2, "0");
                                            const day = jalaaliDate.jd
                                              .toString()
                                              .padStart(2, "0");
                                            const hours = date
                                              .getHours()
                                              .toString()
                                              .padStart(2, "0");
                                            const minutes = date
                                              .getMinutes()
                                              .toString()
                                              .padStart(2, "0");
                                            const seconds = date
                                              .getSeconds()
                                              .toString()
                                              .padStart(2, "0");

                                            return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                          }
                                        }
                                      })()}
                                    </span>
                                  </div>
                                </td>
                                {/* <td
                                  className={
                                    CheckPrice(
                                      itemPro.companyStorePrices.find(
                                        (w) =>
                                          w.companyStoreId ==
                                          itemstore.companyStoreId
                                      )?.price,
                                      LstPrice.find(
                                        (e) =>
                                          e.ProductId == itemPro.id &&
                                          e.CompanyStoreId ==
                                            itemstore.companyStoreId
                                      )?.Price
                                    ) +
                                    (new Date(
                                      itemPro.companyStorePrices.find(
                                        (w) =>
                                          w.companyStoreId ==
                                          itemstore.companyStoreId
                                      )?.createdDate
                                    ) <
                                    new Date(
                                      new Date().setDate(
                                        new Date().getDate() - 1
                                      )
                                    )
                                      ? " bg-warning"
                                      : "")
                                  }
                                >

                                </td> */}
                                <td
                                  className={CheckPrice(
                                    itemPro.companyStorePrices.find(
                                      (w) =>
                                        w.companyStoreId ==
                                        itemstore.companyStoreId,
                                    )?.price,
                                    LstPrice.find(
                                      (e) =>
                                        e.ProductId == itemPro.id &&
                                        e.CompanyStoreId ==
                                          itemstore.companyStoreId,
                                    )?.Price,
                                  )}
                                >
                                  {itemPro.companyStoreStocks?.find(
                                    (w) =>
                                      w.companyStoreId ==
                                      itemstore.companyStoreId,
                                  )?.stock > 0 && (
                                    <input
                                      style={{ width: "90px" }}
                                      onFocus={() => {
                                        ManageActiveItem(itemPro);
                                      }}
                                      className={checkColor(
                                        itemPro.id,
                                        itemstore.companyStoreId,
                                        itemPro.companyStoreAverageRates.find(
                                          (w) =>
                                            w.companyStoreId ==
                                            itemstore.companyStoreId,
                                        )?.price,
                                      )}
                                      id={
                                        itemPro.id +
                                        "-" +
                                        itemstore.companyStoreId
                                      }
                                      ref={(el) =>
                                        (inputRefs.current[
                                          itemPro.id +
                                            "-" +
                                            itemstore.companyStoreId
                                        ] = el)
                                      }
                                      onKeyDown={(e) => {
                                        const currentIndex = DataSort.findIndex(
                                          (item) => item == e.target.id,
                                        );
                                        if (
                                          e.key === "Enter" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                          const nextItem =
                                            DataSort[currentIndex + 1];
                                          if (nextItem) {
                                            inputRefs.current[
                                              nextItem
                                            ]?.focus();
                                            setTimeout(() => {
                                              inputRefs.current[
                                                nextItem
                                              ]?.select();
                                            }, 0);
                                          }
                                        } else if (e.key === "ArrowUp") {
                                          e.preventDefault();
                                          const prevItem =
                                            DataSort[currentIndex - 1];
                                          if (prevItem) {
                                            inputRefs.current[
                                              prevItem
                                            ]?.focus();
                                            setTimeout(() => {
                                              inputRefs.current[
                                                prevItem
                                              ]?.select();
                                            }, 0);
                                          }
                                        }
                                      }}
                                      value={LstPrice.find(
                                        (e) =>
                                          e.ProductId == itemPro.id &&
                                          e.CompanyStoreId ==
                                            itemstore.companyStoreId,
                                      )
                                        ?.Price.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                      onChange={(e) => {
                                        handleChangeSearch(
                                          itemPro.id,
                                          itemstore.companyStoreId,
                                          e,
                                        );
                                      }}
                                    />
                                  )}
                                </td>
                                {ManageSod(
                                  itemPro.id,
                                  itemstore.companyStoreId,
                                )}
                              </tr>
                            ))}

                          {[...Data.allCompany].slice(1).map((itemCompany) => (
                            <>
                              <tr>
                                <td
                                  rowSpan={
                                    Data.allStore.filter(
                                      (w) =>
                                        w.companyStoreCompanyId ==
                                        itemCompany.companyId,
                                    ).length
                                  }
                                >
                                  {itemCompany.companyName}
                                </td>
                                <td>
                                  {
                                    Data.allStore.filter(
                                      (w) =>
                                        w.companyStoreCompanyId ==
                                        itemCompany.companyId,
                                    )[0].companyStoreName
                                  }
                                </td>
                                <td>
                                  {
                                    itemPro.companyStoreStocks.find(
                                      (w) =>
                                        w.companyStoreId ==
                                        Data.allStore.filter(
                                          (w) =>
                                            w.companyStoreCompanyId ==
                                            itemCompany.companyId,
                                        )[0].companyStoreId,
                                    )?.stock
                                  }
                                </td>
                                <td>
                                  <div className="d-flex flex-column justify-content-center align-items-center">
                                    {!isNaN(
                                      Math.floor(
                                        itemPro.companyStoreAverageRates.find(
                                          (w) =>
                                            w.companyStoreId ==
                                            Data.allStore.filter(
                                              (w) =>
                                                w.companyStoreCompanyId ==
                                                itemCompany.companyId,
                                            )[0].companyStoreId,
                                        )?.price,
                                      ),
                                    )
                                      ? Math.floor(
                                          itemPro.companyStoreAverageRates.find(
                                            (w) =>
                                              w.companyStoreId ==
                                              Data.allStore.filter(
                                                (w) =>
                                                  w.companyStoreCompanyId ==
                                                  itemCompany.companyId,
                                              )[0].companyStoreId,
                                          )?.price,
                                        )
                                          ?.toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      : ""}
                                    {itemPro.companyStoreAverageRates.find(
                                      (w) =>
                                        w.companyStoreId ==
                                        Data.allStore.filter(
                                          (w) =>
                                            w.companyStoreCompanyId ==
                                            itemCompany.companyId,
                                        )[0].companyStoreId,
                                    )?.isWarning && (
                                      <img
                                        width={"20px"}
                                        height={"20px"}
                                        src={warning}
                                      />
                                    )}
                                  </div>
                                </td>

                                {[
                                  ...new Set(
                                    Data.allUserOffer.map(
                                      (item) => item.userId,
                                    ),
                                  ),
                                ].map((itemOffer) => (
                                  <td>
                                    {(() => {
                                      const storeId = Data.allStore.filter(
                                        (w) =>
                                          w.companyStoreCompanyId ==
                                          itemCompany.companyId,
                                      )[0].companyStoreId;
                                      if (!storeId) return "";

                                      const lastTiem = Data.allUserOffer.find(
                                        (q) =>
                                          q.userId === itemOffer &&
                                          q.storeId === storeId,
                                      )?.lastTiem;
                                      if (!lastTiem) return "";

                                      const priceItem =
                                        itemPro.companyStoreOfferPrices.find(
                                          (w) =>
                                            w.companyStoreId === storeId &&
                                            w.userId === itemOffer &&
                                            w.createdDate === lastTiem,
                                        );

                                      if (!priceItem) return "";

                                      return priceItem.price
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    })()}
                                  </td>
                                ))}
                                <td>
                                  {() => {
                                    let a = OfferPriceSystem1(
                                      itemPro.id,
                                      Data.allStore.filter(
                                        (w) =>
                                          w.companyStoreCompanyId ==
                                          itemCompany.companyId,
                                      )[0].companyStoreId,
                                    );
                                    if (a == 0 || a == undefined) {
                                      return "-";
                                    } else {
                                      return a
                                        ?.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    }
                                  }}
                                </td>
                                <td>
                                  {(() => {
                                    let a = OfferPriceSystem2(
                                      itemPro.id,
                                      Data.allStore.filter(
                                        (w) =>
                                          w.companyStoreCompanyId ==
                                          itemCompany.companyId,
                                      )[0].companyStoreId,
                                    );
                                    if (a == 0 || a == undefined) {
                                      return "-";
                                    } else {
                                      return a
                                        ?.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    }
                                  })()}
                                </td>
                                <td
                                  className={
                                    CheckPrice(
                                      itemPro.companyStorePrices.find(
                                        (w) =>
                                          w.companyStoreId ==
                                          Data.allStore.filter(
                                            (w) =>
                                              w.companyStoreCompanyId ==
                                              itemCompany.companyId,
                                          )[0].companyStoreId,
                                      )?.price,
                                      LstPrice.find(
                                        (e) =>
                                          e.ProductId == itemPro.id &&
                                          e.CompanyStoreId ==
                                            Data.allStore.filter(
                                              (w) =>
                                                w.companyStoreCompanyId ==
                                                itemCompany.companyId,
                                            )[0].companyStoreId,
                                      )?.Price,
                                    ) +
                                    (new Date(
                                      itemPro.companyStorePrices.find(
                                        (w) =>
                                          w.companyStoreId ==
                                          Data.allStore.filter(
                                            (w) =>
                                              w.companyStoreCompanyId ==
                                              itemCompany.companyId,
                                          )[0].companyStoreId,
                                      )?.createdDate,
                                    ) <
                                    new Date(
                                      new Date().setDate(
                                        new Date().getDate() - 1,
                                      ),
                                    )
                                      ? " bg-warning"
                                      : "")
                                  }
                                >
                                  <div className="d-flex flex-column justify-content-center align-items.center">
                                    <span>
                                      {itemPro.companyStorePrices
                                        .find(
                                          (w) =>
                                            w.companyStoreId ==
                                            Data.allStore.filter(
                                              (w) =>
                                                w.companyStoreCompanyId ==
                                                itemCompany.companyId,
                                            )[0].companyStoreId,
                                        )
                                        ?.price.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </span>
                                    <span>
                                      {(() => {
                                        let a = itemPro.companyStorePrices.find(
                                          (w) =>
                                            w.companyStoreId ==
                                            Data.allStore.filter(
                                              (w) =>
                                                w.companyStoreCompanyId ==
                                                itemCompany.companyId,
                                            )[0].companyStoreId,
                                        );
                                        if (a) {
                                          const date = new Date(
                                            a.createdDate.replace("T", " "),
                                          );
                                          if (date) {
                                            const jalaaliDate =
                                              jalaali.toJalaali(date);
                                            const year = jalaaliDate.jy;
                                            const month = jalaaliDate.jm
                                              .toString()
                                              .padStart(2, "0");
                                            const day = jalaaliDate.jd
                                              .toString()
                                              .padStart(2, "0");
                                            const hours = date
                                              .getHours()
                                              .toString()
                                              .padStart(2, "0");
                                            const minutes = date
                                              .getMinutes()
                                              .toString()
                                              .padStart(2, "0");
                                            const seconds = date
                                              .getSeconds()
                                              .toString()
                                              .padStart(2, "0");

                                            return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                          }
                                        }
                                      })()}
                                    </span>
                                  </div>
                                </td>
                                {/* <td
                                  className={
                                    CheckPrice(
                                      itemPro.companyStorePrices.find(
                                        (w) =>
                                          w.companyStoreId ==
                                          Data.allStore.filter(
                                            (w) =>
                                              w.companyStoreCompanyId ==
                                              itemCompany.companyId
                                          )[0].companyStoreId
                                      )?.price,
                                      LstPrice.find(
                                        (e) =>
                                          e.ProductId == itemPro.id &&
                                          e.CompanyStoreId ==
                                            Data.allStore.filter(
                                              (w) =>
                                                w.companyStoreCompanyId ==
                                                itemCompany.companyId
                                            )[0].companyStoreId
                                      )?.Price
                                    ) +
                                    (new Date(
                                      itemPro.companyStorePrices.find(
                                        (w) =>
                                          w.companyStoreId ==
                                          Data.allStore.filter(
                                            (w) =>
                                              w.companyStoreCompanyId ==
                                              itemCompany.companyId
                                          )[0].companyStoreId
                                      )?.createdDate
                                    ) <
                                    new Date(
                                      new Date().setDate(
                                        new Date().getDate() - 1
                                      )
                                    )
                                      ? " bg-warning"
                                      : "")
                                  }
                                >
                                  {itemPro.companyStorePrices
                                    .find(
                                      (w) =>
                                        w.companyStoreId ==
                                        Data.allStore.filter(
                                          (w) =>
                                            w.companyStoreCompanyId ==
                                            itemCompany.companyId
                                        )[0].companyStoreId
                                    )
                                    ?.price.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td> */}
                                <td
                                  className={CheckPrice(
                                    itemPro.companyStorePrices.find(
                                      (w) =>
                                        w.companyStoreId ==
                                        Data.allStore.filter(
                                          (w) =>
                                            w.companyStoreCompanyId ==
                                            itemCompany.companyId,
                                        )[0].companyStoreId,
                                    )?.price,
                                    LstPrice.find(
                                      (e) =>
                                        e.ProductId == itemPro.id &&
                                        e.CompanyStoreId ==
                                          Data.allStore.filter(
                                            (w) =>
                                              w.companyStoreCompanyId ==
                                              itemCompany.companyId,
                                          )[0].companyStoreId,
                                    )?.Price,
                                  )}
                                >
                                  {itemPro.companyStoreStocks?.find(
                                    (w) =>
                                      w.companyStoreId ==
                                      Data.allStore.filter(
                                        (w) =>
                                          w.companyStoreCompanyId ==
                                          itemCompany.companyId,
                                      )[0].companyStoreId,
                                  )?.stock > 0 && (
                                    <input
                                      style={{ width: "90px" }}
                                      onFocus={() => {
                                        ManageActiveItem(itemPro);
                                      }}
                                      className={checkColor(
                                        itemPro.id,
                                        Data.allStore.filter(
                                          (w) =>
                                            w.companyStoreCompanyId ==
                                            itemCompany.companyId,
                                        )[0].companyStoreId,
                                        itemPro.companyStoreAverageRates.find(
                                          (w) =>
                                            w.companyStoreId ==
                                            Data.allStore.filter(
                                              (w) =>
                                                w.companyStoreCompanyId ==
                                                itemCompany.companyId,
                                            )[0].companyStoreId,
                                        )?.price,
                                      )}
                                      id={
                                        itemPro.id +
                                        "-" +
                                        Data.allStore.filter(
                                          (w) =>
                                            w.companyStoreCompanyId ==
                                            itemCompany.companyId,
                                        )[0].companyStoreId
                                      }
                                      ref={(el) =>
                                        (inputRefs.current[
                                          itemPro.id +
                                            "-" +
                                            Data.allStore.filter(
                                              (w) =>
                                                w.companyStoreCompanyId ==
                                                itemCompany.companyId,
                                            )[0].companyStoreId
                                        ] = el)
                                      }
                                      onKeyDown={(e) => {
                                        const currentIndex = DataSort.findIndex(
                                          (item) => item == e.target.id,
                                        );
                                        if (
                                          e.key === "Enter" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                          const nextItem =
                                            DataSort[currentIndex + 1];
                                          if (nextItem) {
                                            inputRefs.current[
                                              nextItem
                                            ]?.focus();
                                            setTimeout(() => {
                                              inputRefs.current[
                                                nextItem
                                              ]?.select();
                                            }, 0);
                                          }
                                        } else if (e.key === "ArrowUp") {
                                          e.preventDefault();
                                          const prevItem =
                                            DataSort[currentIndex - 1];
                                          if (prevItem) {
                                            inputRefs.current[
                                              prevItem
                                            ]?.focus();
                                            setTimeout(() => {
                                              inputRefs.current[
                                                prevItem
                                              ]?.select();
                                            }, 0);
                                          }
                                        }
                                      }}
                                      value={LstPrice.find(
                                        (e) =>
                                          e.ProductId == itemPro.id &&
                                          e.CompanyStoreId ==
                                            Data.allStore.filter(
                                              (w) =>
                                                w.companyStoreCompanyId ==
                                                itemCompany.companyId,
                                            )[0].companyStoreId,
                                      )
                                        ?.Price.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                      onChange={(e) => {
                                        handleChangeSearch(
                                          itemPro.id,
                                          Data.allStore.filter(
                                            (w) =>
                                              w.companyStoreCompanyId ==
                                              itemCompany.companyId,
                                          )[0].companyStoreId,
                                          e,
                                        );
                                      }}
                                    />
                                  )}
                                </td>
                                {ManageSod(
                                  itemPro.id,
                                  Data.allStore.filter(
                                    (w) =>
                                      w.companyStoreCompanyId ==
                                      itemCompany.companyId,
                                  )[0].companyStoreId,
                                )}
                              </tr>
                              {Data.allStore
                                .filter(
                                  (w) =>
                                    w.companyStoreCompanyId ==
                                    itemCompany.companyId,
                                )
                                .slice(1)
                                .map((itemStore) => (
                                  <tr>
                                    <td>{itemStore.companyStoreName}</td>
                                    <td>
                                      {
                                        itemPro.companyStoreStocks.find(
                                          (w) =>
                                            w.companyStoreId ==
                                            itemStore.companyStoreId,
                                        )?.stock
                                      }
                                    </td>
                                    <td>
                                      <div className="d-flex flex-column justify-content-center align-items-center">
                                        {!isNaN(
                                          Math.floor(
                                            itemPro.companyStoreAverageRates.find(
                                              (w) =>
                                                w.companyStoreId ==
                                                itemStore.companyStoreId,
                                            )?.price,
                                          ),
                                        )
                                          ? Math.floor(
                                              itemPro.companyStoreAverageRates.find(
                                                (w) =>
                                                  w.companyStoreId ==
                                                  itemStore.companyStoreId,
                                              )?.price,
                                            )
                                              ?.toString()
                                              .replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ",",
                                              )
                                          : ""}
                                        {itemPro.companyStoreAverageRates.find(
                                          (w) =>
                                            w.companyStoreId ==
                                            itemStore.companyStoreId,
                                        )?.isWarning && (
                                          <img
                                            width={"20px"}
                                            height={"20px"}
                                            src={warning}
                                          />
                                        )}
                                      </div>
                                    </td>

                                    {[
                                      ...new Set(
                                        Data.allUserOffer.map(
                                          (item) => item.userId,
                                        ),
                                      ),
                                    ].map((itemOffer) => (
                                      <td>
                                        {(() => {
                                          const storeId =
                                            itemStore.companyStoreId;
                                          if (!storeId) return "";

                                          const lastTiem =
                                            Data.allUserOffer.find(
                                              (q) =>
                                                q.userId === itemOffer &&
                                                q.storeId === storeId,
                                            )?.lastTiem;

                                          if (!lastTiem) return "";

                                          const priceItem =
                                            itemPro.companyStoreOfferPrices.find(
                                              (w) =>
                                                w.companyStoreId === storeId &&
                                                w.userId === itemOffer &&
                                                w.createdDate === lastTiem,
                                            );

                                          if (!priceItem) return "";

                                          return priceItem.price
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            );
                                        })()}
                                      </td>
                                    ))}
                                    <td>
                                      {(() => {
                                        let a = OfferPriceSystem1(
                                          itemPro.id,
                                          itemStore.companyStoreId,
                                        );
                                        if (a == 0 || a == undefined) {
                                          return "-";
                                        } else {
                                          return a
                                            ?.toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            );
                                        }
                                      })()}
                                    </td>
                                    <td>
                                      {(() => {
                                        let a = OfferPriceSystem2(
                                          itemPro.id,
                                          itemStore.companyStoreId,
                                        );
                                        if (a == 0 || a == undefined) {
                                          return "-";
                                        } else {
                                          return a
                                            ?.toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            );
                                        }
                                      })()}
                                    </td>
                                    <td
                                      className={
                                        CheckPrice(
                                          itemPro.companyStorePrices.find(
                                            (w) =>
                                              w.companyStoreId ==
                                              itemStore.companyStoreId,
                                          )?.price,
                                          LstPrice.find(
                                            (e) =>
                                              e.ProductId == itemPro.id &&
                                              e.CompanyStoreId ==
                                                itemStore.companyStoreId,
                                          )?.Price,
                                        ) +
                                        (new Date(
                                          itemPro.companyStorePrices.find(
                                            (w) =>
                                              w.companyStoreId ==
                                              itemStore.companyStoreId,
                                          )?.createdDate,
                                        ) <
                                        new Date(
                                          new Date().setDate(
                                            new Date().getDate() - 1,
                                          ),
                                        )
                                          ? " bg-warning"
                                          : "")
                                      }
                                    >
                                      <div className="d-flex flex-column justify-content-center align-items.center">
                                        <span>
                                          {itemPro.companyStorePrices
                                            .find(
                                              (w) =>
                                                w.companyStoreId ==
                                                itemStore.companyStoreId,
                                            )
                                            ?.price.toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            )}
                                        </span>
                                        <span>
                                          {(() => {
                                            let a =
                                              itemPro.companyStorePrices.find(
                                                (w) =>
                                                  w.companyStoreId ==
                                                  itemStore.companyStoreId,
                                              );
                                            if (a) {
                                              const date = new Date(
                                                a.createdDate.replace("T", " "),
                                              );
                                              if (date) {
                                                const jalaaliDate =
                                                  jalaali.toJalaali(date);
                                                const year = jalaaliDate.jy;
                                                const month = jalaaliDate.jm
                                                  .toString()
                                                  .padStart(2, "0");
                                                const day = jalaaliDate.jd
                                                  .toString()
                                                  .padStart(2, "0");
                                                const hours = date
                                                  .getHours()
                                                  .toString()
                                                  .padStart(2, "0");
                                                const minutes = date
                                                  .getMinutes()
                                                  .toString()
                                                  .padStart(2, "0");
                                                const seconds = date
                                                  .getSeconds()
                                                  .toString()
                                                  .padStart(2, "0");

                                                return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                              }
                                            }
                                          })()}
                                        </span>
                                      </div>
                                    </td>
                                    {/* <td
                                      className={
                                        CheckPrice(
                                          itemPro.companyStorePrices.find(
                                            (w) =>
                                              w.companyStoreId ==
                                              itemStore.companyStoreId
                                          )?.price,
                                          LstPrice.find(
                                            (e) =>
                                              e.ProductId == itemPro.id &&
                                              e.CompanyStoreId ==
                                                itemStore.companyStoreId
                                          )?.Price
                                        ) +
                                        (new Date(
                                          itemPro.companyStorePrices.find(
                                            (w) =>
                                              w.companyStoreId ==
                                              itemStore.companyStoreId
                                          )?.createdDate
                                        ) <
                                        new Date(
                                          new Date().setDate(
                                            new Date().getDate() - 1
                                          )
                                        )
                                          ? " bg-warning"
                                          : "")
                                      }
                                    >
                                      {itemPro.companyStorePrices
                                        .find(
                                          (w) =>
                                            w.companyStoreId ==
                                            itemStore.companyStoreId
                                        )
                                        ?.price.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td> */}
                                    <td
                                      className={CheckPrice(
                                        itemPro.companyStorePrices.find(
                                          (w) =>
                                            w.companyStoreId ==
                                            itemStore.companyStoreId,
                                        )?.price,
                                        LstPrice.find(
                                          (e) =>
                                            e.ProductId == itemPro.id &&
                                            e.CompanyStoreId ==
                                              itemStore.companyStoreId,
                                        )?.Price,
                                      )}
                                    >
                                      {itemPro.companyStoreStocks?.find(
                                        (w) =>
                                          w.companyStoreId ==
                                          itemStore.companyStoreId,
                                      )?.stock > 0 && (
                                        <input
                                          style={{ width: "90px" }}
                                          onFocus={() => {
                                            ManageActiveItem(itemPro);
                                          }}
                                          className={checkColor(
                                            itemPro.id,
                                            itemStore.companyStoreId,
                                            itemPro.companyStoreAverageRates.find(
                                              (w) =>
                                                w.companyStoreId ==
                                                itemStore.companyStoreId,
                                            )?.price,
                                          )}
                                          id={
                                            itemPro.id +
                                            "-" +
                                            itemStore.companyStoreId
                                          }
                                          ref={(el) =>
                                            (inputRefs.current[
                                              itemPro.id +
                                                "-" +
                                                itemStore.companyStoreId
                                            ] = el)
                                          }
                                          onKeyDown={(e) => {
                                            const currentIndex =
                                              DataSort.findIndex(
                                                (item) => item == e.target.id,
                                              );
                                            if (
                                              e.key === "Enter" ||
                                              e.key === "ArrowDown"
                                            ) {
                                              e.preventDefault();
                                              const nextItem =
                                                DataSort[currentIndex + 1];
                                              if (nextItem) {
                                                inputRefs.current[
                                                  nextItem
                                                ]?.focus();
                                                setTimeout(() => {
                                                  inputRefs.current[
                                                    nextItem
                                                  ]?.select();
                                                }, 0);
                                              }
                                            } else if (e.key === "ArrowUp") {
                                              e.preventDefault();
                                              const prevItem =
                                                DataSort[currentIndex - 1];
                                              if (prevItem) {
                                                inputRefs.current[
                                                  prevItem
                                                ]?.focus();
                                                setTimeout(() => {
                                                  inputRefs.current[
                                                    prevItem
                                                  ]?.select();
                                                }, 0);
                                              }
                                            }
                                          }}
                                          value={LstPrice.find(
                                            (e) =>
                                              e.ProductId == itemPro.id &&
                                              e.CompanyStoreId ==
                                                itemStore.companyStoreId,
                                          )
                                            ?.Price.toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            )}
                                          onChange={(e) => {
                                            handleChangeSearch(
                                              itemPro.id,
                                              itemStore.companyStoreId,
                                              e,
                                            );
                                          }}
                                        />
                                      )}
                                    </td>
                                    {ManageSod(
                                      itemPro.id,
                                      itemStore.companyStoreId,
                                    )}
                                  </tr>
                                ))}
                            </>
                          ))}

                          {ActiveItem.End == itemPro.id && (
                            <>
                              <tr className="bg-warning">
                                <td colSpan={100}></td>
                              </tr>
                              <tr className="bg-warning">
                                <td colSpan={100}></td>
                              </tr>
                            </>
                          )}
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div className="d-flex justify-content-start align-items-center w-100 m-5">
                <button onClick={Add} className="butAU">
                  ثبت
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PricesAE;
